/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type verifyTempoTokenInput = {|
  token?: ?string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type VerifyTempoTokenMutationVariables = {|
  input: verifyTempoTokenInput
|};
export type VerifyTempoTokenMutationResponse = {|
  +verifyTempoToken: ?{|
    +statusCode: ?number,
    +worklogCount: ?number,
  |}
|};
export type VerifyTempoTokenMutation = {|
  variables: VerifyTempoTokenMutationVariables,
  response: VerifyTempoTokenMutationResponse,
|};
*/


/*
mutation VerifyTempoTokenMutation(
  $input: verifyTempoTokenInput!
) {
  verifyTempoToken(input: $input) {
    statusCode
    worklogCount
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "verifyTempoTokenInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "verifyTempoTokenPayload",
    "kind": "LinkedField",
    "name": "verifyTempoToken",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "worklogCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VerifyTempoTokenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VerifyTempoTokenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "VerifyTempoTokenMutation",
    "operationKind": "mutation",
    "text": "mutation VerifyTempoTokenMutation(\n  $input: verifyTempoTokenInput!\n) {\n  verifyTempoToken(input: $input) {\n    statusCode\n    worklogCount\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4a196231780f6b993d4605548940ee59';

module.exports = node;
